import { render, staticRenderFns } from "./Reagendar.vue?vue&type=template&id=2af8c4d0&scoped=true&"
import script from "./Reagendar.vue?vue&type=script&lang=js&"
export * from "./Reagendar.vue?vue&type=script&lang=js&"
import style0 from "./Reagendar.vue?vue&type=style&index=0&id=2af8c4d0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8c4d0",
  null
  
)

export default component.exports